export { default } from './ImageGradient';
